import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NavigationBar = ({token, onOpenAccountInfo, onShowSupporters , onShowShare, onShowOtherSun, onLogout, isLoggedIn   }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    // return (
    //     <div style={{ position: 'fixed', right: 0, top: 0, height: '100%', zIndex: 1000 }}>
    //         {/* Toggle Button */}
    //         <button
    //             onClick={toggleSidebar}
    //             style={{
    //                 position: 'absolute',
    //                 left: isOpen ? '-40px' : '-80px',
    //                 top: '20px',
    //                 transform: 'rotate(-90deg)',
    //                 transformOrigin: 'top left',
    //                 padding: '10px',
    //                 cursor: 'pointer',
    //                 background: '#007BFF',
    //                 color: '#fff',
    //                 border: 'none',
    //             }}
    //         >
    //             {isOpen ? 'Close' : 'Menu'}
    //         </button>

    //         {/* Sidebar */}
    //         <div
    //             style={{
    //                 width: isOpen ? '200px' : '0',
    //                 height: '100%',
    //                 overflowX: 'hidden',
    //                 transition: '0.3s',
    //                 background: '#f4f4f4',
    //                 boxShadow: isOpen ? '-2px 0 5px rgba(0,0,0,0.2)' : 'none',
    //                 display: 'flex',
    //                 flexDirection: 'column',
    //                 justifyContent: 'flex-start',
    //                 padding: isOpen ? '20px' : '0',
    //             }}
    //         >
    //             {isOpen && (
    //                 <>
    //                     <button onClick={onOpenAccountInfo} style={{ marginBottom: '10px' }}>
    //                         2025 소원/다짐 하기
    //                     </button>
    //                     <button onClick={onShowSupporters}>나의 해를 보러 온 사람들</button>
    //                     <button onClick={onShowShare}>공유하기</button>
    //                     <nav style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#f0f0f0' }}>
    //                         <div>
    //                             <Link to="/mySun" style={{ marginRight: '10px' }}>My Sun</Link>
    //                             <Link to="/profile" style={{ marginRight: '10px' }}>Profile</Link>
    //                         </div>
    //                         <div>
    //                             {isLoggedIn ? (
    //                                 <button onClick={onLogout} style={{ padding: '5px 10px' }}>
    //                                     Logout
    //                                 </button>
    //                             ) : (
    //                                 <Link to="/">Login</Link>
    //                             )}
    //                         </div>
    //                     </nav>
    //                 </>
    //             )}
    //         </div>

    //     </div>
    // );
    // return (
    //     <div className="sidebar-container">
    //       {/* 토글 버튼 */}
    //       <button className="toggle-button" onClick={toggleSidebar} style={{ left: isOpen ? '-40px' : '-80px' }}>
    //         {isOpen ? 'Close' : 'Menu'}
    //       </button>
    
    //       {/* 사이드바 영역 */}
    //       <div className={`sidebar ${isOpen ? 'open' : ''}`}>
    //         {isOpen && (
    //           <>
    //             <button className="sidebar-button" onClick={onOpenAccountInfo}>
    //               2025 소원/다짐 하기
    //             </button>
    //             <button className="sidebar-button" onClick={onShowSupporters}>
    //               나의 해를 보러 온 사람들
    //             </button>
    //             <button className="sidebar-button" onClick={onShowOtherSun}>
    //               다른 사람의 해 찾아보기
    //             </button>
    //             <button className="sidebar-button" onClick={onShowShare}>
    //               공유하기
    //             </button>
                
    //             <nav className="sidebar-nav">
    //               <div>
    //                 <Link to="/mySun" className="sidebar-link">My Sun</Link>
    //                 <Link to="/profile" className="sidebar-link">Profile</Link>
    //               </div>
    //               <div>
    //                 {isLoggedIn ? (
    //                   <button className="sidebar-button" onClick={onLogout}>
    //                     Logout
    //                   </button>
    //                 ) : (
    //                   <Link to="/" className="sidebar-link">Login</Link>
    //                 )}
    //               </div>
    //             </nav>
    //           </>
    //         )}
    //       </div>
    //     </div>
    //   );
    
    return (token ? ( 
      <div className="sidebar-container">
        {/* 토글 버튼 */}
        <button className="toggle-button" onClick={toggleSidebar} style={{ left: isOpen ? '-40px' : '-80px' }}>
          {isOpen ? 'Close' : 'Menu'}
        </button>
        t
        {/* 사이드바 영역 */}
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
          {isOpen && (
            <>
              {/* 사이드바 버튼 */}
              <button className="sidebar-button" onClick={onOpenAccountInfo}>
                2025 소원/다짐 하기
              </button>
              <button className="sidebar-button" onClick={onShowSupporters}>
                나의 해를 보러 온 사람들
              </button>
              <button className="sidebar-button" onClick={onShowOtherSun}>
                다른 사람의 해 찾아보기
              </button>
              <button className="sidebar-button" onClick={onShowShare}>
                공유하기
              </button>
              <hr className="sidebar-divider" />
              {/* 추가된 Link 요소 */}
              <Link to="/mySun" className="sidebar-button">
                나의 해 보러가기
              </Link>
              <Link to="/profile" className="sidebar-button">
                나의 정보 수정하기
              </Link>
              <hr className="sidebar-divider" />
              {isLoggedIn ? (
                <button className="sidebar-button" onClick={onLogout}>
                  로그아웃
                </button>
              ) : (
                <Link to="/" className="sidebar-button">
                  로그인
                </Link>
              )}
              <hr className="sidebar-divider" />
              <a href="https://heather-thumb-567.notion.site/2025-1882a47d278d8053aa68e4a043d8ef24" className="sidebar-button">개발자 정보보기</a>
            </>
          )}
        </div>
      </div>
      ):(
        <div className="sidebar-container">
        {/* 토글 버튼 */}
        <button className="toggle-button" onClick={toggleSidebar} style={{ left: isOpen ? '-40px' : '-80px' }}>
          {isOpen ? 'Close' : 'Menu'}
        </button>
        t
        {/* 사이드바 영역 */}
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
          {isOpen && (
            <>
              {isLoggedIn ? (
                <button className="sidebar-button" onClick={onLogout}>
                  로그아웃
                </button>
              ) : (
                <Link to="/" className="sidebar-button">
                  로그인
                </Link>
              )}
              <hr className="sidebar-divider" />
              <a href="https://heather-thumb-567.notion.site/2025-1882a47d278d8053aa68e4a043d8ef24" className="sidebar-button">개발자 정보보기</a>
            </>
          )}
        </div>
      </div>

      )
    );
};

export default NavigationBar;
